import { memo } from "react";
import { CreditNoteVesselTablePanel } from "./Table/CreditNoteVesselTablePanel";

const CreditNoteVesselContent: React.FC = () => {
        return <div className={`main-comp-wrapper`} style={{ width: "60vw", height: "69vh" }}>
                <CreditNoteVesselTablePanel />
        </div>
}

export default memo(CreditNoteVesselContent);